<template>
  <span class="dots-pulse" role="status" aria-label="Working">
    <i class="fa-solid fa-circle"></i>
    <i class="fa-solid fa-circle"></i>
    <i class="fa-solid fa-circle"></i>
  </span>
</template>
<style scoped>
/* make it look like small dots and animate */
.dots-pulse {
  display: inline-flex;
  align-items: center;
  gap: 0.35em;
  font-size: 0.8em; /* overall size; tweak to taste */
  color: currentColor; /* inherits text color */
}
.dots-pulse .fa-circle {
  opacity: 0.35;
  transform: scale(0.6);
  animation: dotsPulse 1.2s ease-in-out infinite;
}
.dots-pulse .fa-circle:nth-child(2) {
  animation-delay: 0.2s;
}
.dots-pulse .fa-circle:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotsPulse {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.35;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
